<script>
  import { link } from "svelte-routing";
  import { config } from "../../stores/config.js";
  import { onMount, onDestroy } from "svelte";
  import Logo from "../Logo.svelte";

  let scrolled = false;

  function handleScroll() {
    scrolled = window.scrollY > 8;
  }

  onMount(() => {
    window.addEventListener('scroll', handleScroll);
  });

  onDestroy(() => {
    window.removeEventListener('scroll', handleScroll);
  });
</script>

<nav
  class="fixed top-0 z-50 w-full transition-all duration-200 border-b
    {scrolled ? 'bg-white/95 backdrop-blur border-line' : 'bg-transparent border-transparent'}"
>
  <div class="max-w-6xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
    <a use:link href="/" aria-label="Moira Finance home">
      <Logo />
    </a>
    {#if $config.authEnabled}
      <a use:link href="/auth/login" class="btn btn-outline btn-sm">
        Sign in
      </a>
    {/if}
  </div>
</nav>
